import { getUnifyTime, dayjs } from '@el-plus/utils/time'
import { Cookies } from '@el-plus/utils/cookie'
import { importFile, downloadFile, previewFile } from '@el-plus/utils/file'

export const useUtils = () => {
  return {
    getUnifyTime,
    dayjs,
    importFile,
    downloadFile,
    previewFile,
    Cookies,
  }
}
